// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#25776b","secondaryColor":"#3098ff","linkColor":"#25776b","successColor":"#25776b","infoColor":"#64d6c3"};